<script>
  import { Link, navigate } from "svelte-routing";

  import roomStore from 'src/stores/Room';

  export let conn, token;

  const leave = () => {
    conn.send(JSON.stringify({
      action: 'leave'
    }));
  }

  const close = () => {
    conn.send(JSON.stringify({
      action: 'close'
    }));
  }
</script>
<nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
    <!-- Navbar Brand-->
    <Link class="navbar-brand ps-3" to="dashboard">Pointing Poker</Link>
    <!-- Spacer -->
    <form class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
        <!-- Spacer to push the user icon right -->
    </form>
    <!-- Navbar-->
    <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-user fa-fw"></i></a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" href="#!" on:click={() => leave()}>Leave Room</a></li>
                {#if $roomStore.me.id == token}
                  <li><a class="dropdown-item" href="#!" on:click={() => close()}>Close Room</a></li>
                {/if}
            </ul>
        </li>
    </ul>
</nav>
